import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";

import HistoryList from "./HistoryList";

const CMSHistory = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs
        noTranslate
        cms
        pageName={t({ defaultMessage: "内容历史" })}
      />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "内容历史" })}
        </Typography>
      </div>
      <div className={classes.paperWrapper}>
        <HistoryList />
      </div>
    </>
  );
};

export default CMSHistory;
